import { themeTokens as atlasThemeTokens } from "@diligentcorp/atlas-design-tokens/index.js";
import { themeTokens } from "@diligentcorp/atlas-design-tokens/lens.js";
import { getLensPresets } from "./getLensPresets.js";
import { getLensThemeOptions } from "./getLensThemeOptions.js";
export const lensThemeOptions = getLensThemeOptions(themeTokens, atlasThemeTokens);
export const presets = getLensPresets(themeTokens);
//# sourceMappingURL=index.js.map